/** 可存檔的亂數（mulberry32）。狀態存在 DayState.rng，回溯時一起還原，結果可重現。 */
export function nextRandom(state: { rng: number }): number {
  let t = (state.rng = (state.rng + 0x6d2b79f5) | 0);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
export function shuffle<T>(arr: T[], state: { rng: number }): T[] {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(nextRandom(state) * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return a;
}
export const seedFrom = (n: number) => (n * 2654435761) >>> 0;
